module.exports = __webpack_public_path__ + "static/media/plant-really-happy.8e529471.png";